<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="top">
    <el-row :gutter="5">
      <el-col :xs="15" :sm="10" :md="10" :lg="4" :xl="8">
        <el-form-item :label="$t('cnpj')" prop="federalid" class="is-required">
          <el-input v-model="ruleForm.federalid" v-mask="'NN.NNN.NNN/NNNN-##'"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="8">
        <el-form-item :label="$t('razao-social')" prop="companyname" class="is-required">
          <el-input v-model="ruleForm.companyname" maxlength="80"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="12" :sm="12" :md="10" :lg="6" :xl="6">
        <el-form-item :label="$t('inscricao-estadual')" prop="registerState">
          <el-input maxlength="20" v-model="ruleForm.registerState"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :md="10" :lg="6" :xl="6">
        <el-form-item :label="$t('inscricao-municipal')" prop="registerRegional">
          <el-input maxlength="20" v-model="ruleForm.registerRegional"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <ShippingAddFormInfoZipcode ref="zipcode" />

  </el-form>
</template> 
<script>
import ShippingAddFormInfoZipcode from './ShippingAddFormInfoZipcode';

export default {
  name: "ShippingAddFormInfo",
  components: { ShippingAddFormInfoZipcode },
  computed: {
    data() {
      const data = { 
        ...this.$refs.zipcode.data,
        ...this.ruleForm,
      }
      return data;
    }
  },
  methods: {
    setData(ruleForm) {
      this.ruleForm.federalid = ruleForm.federalId;
      this.ruleForm.companyname = ruleForm.companyName;
      this.ruleForm.registerRegional = ruleForm.registerRegional;
      this.ruleForm.registerState = ruleForm.registerState;
      this.$refs.zipcode.setData(ruleForm);
    }
  },
  data() {
    return {
      ruleForm: {
        federalid: "",
        companyname: "",
        registerRegional: "",
        registerState: "",
      }
    };
  },
}
</script>
